require('./builders/choice_builder.ts');
require('./builders/poll_builder.ts');
require('./builders/question_builder.ts');
require('./builders/question_x_choice_builder.ts');
require('./builders/question_x_choice_x_resource_builder.ts');
require('./commands/complete_scheduled_poll_command.ts');
require('./commands/dismiss_scheduled_poll_command.ts');
require('./commands/load_poll_command.ts');
require('./commands/load_poll_results_command.ts');
require('./commands/load_poll_summary.ts');
require('./commands/load_scheduled_polls_command.ts');
require('./commands/update_poll_answer_command.ts');
require('./commands/update_poll_status_command.ts');
require('./components/free_text_poll/free_text_poll.ts');
require('./components/multiple_poll/multiple_poll.ts');
require('./components/poll_components_module.ts');
require('./components/poll_container/poll_container.ts');
require('./components/poll_container/poll_container_controller.ts');
require('./components/results/poll_results/poll_results_component.ts');
require('./components/results/poll_results/poll_results_controller.ts');
require('./components/results/poll_results_pie/poll_results_pie_controller.ts');
require('./components/stand_alone_choice/stand_alone_choice.ts');
require('./datastore/poll_answer_datastore.ts');
require('./datastore/poll_datastore.ts');
require('./datastore/poll_student_datastore.ts');
require('./datastore/scheduled_poll_datastore.ts');
require('./poll_configuration.ts');
require('./poll_interfaces.ts');
require('./poll_routes.ts');
require('./queries/poll_query_model.ts');
require('./queries/poll_results_query_model.ts');
require('./queries/scheduled_poll_query.ts');
require('./servants/check_scheduled_poll_servant.ts');
require('./servants/poll_platform_servant.ts');
require('./servants/poll_results_servant.ts');
require('./types/poll_question_types.ts');
require('./types/question_types.ts');
require('./views/poll/poll.ts');
require('./views/poll_view_module.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/core.ts